import http from "@seims/shared/src/services/HttpService";
var apiEndpoint = `system/user-guides`;
const apiVideoGuideEndpoint = `system/video-guides`;

const axiosConfigs = {
  AlterBaseURL: false,
};


const multiPartHeaders = {
    "Content-Type": "multipart/form-data",
};


const getVideoGuides = async () => {
  const response = http.get(`${apiVideoGuideEndpoint}`);
  return response;
};

const saveVideoGuide = async (payload) => {
  const { uuid = null} = payload;
  
  if (uuid) {
    const response = await http.put(`${apiVideoGuideEndpoint}/${uuid}`, payload);

    return response;
  }
  
  const response = await http.post(
    `${apiVideoGuideEndpoint}`,
    payload,
  );
  
  return response;
};


const patchVideoGuideArchive = async ({uuid, archived}) => {
  const response = await http.patch(`${apiVideoGuideEndpoint}/${uuid}?archived=${archived}`);
  return response;
};


const getUserGuides = async () => {
  const response = http.get(`${apiEndpoint}`);
  return response;
};

const uploadDocument = async (document, targetModule) => {
  const response = await http.post(`${apiEndpoint}/${targetModule}`, document, {
    headers: multiPartHeaders,
    ...axiosConfigs,
  });
  return response;
};


const saveDocument = async (payload) => {
  const {targetModule, archived =  false, document, uuid = null} = payload;

  if (uuid) {
    const response =  await http.put(`${apiEndpoint}/${uuid}?archived=${archived}`, document, {
      headers: multiPartHeaders,
    });
    return response;
  }

  const response = await http.post(`${apiEndpoint}/${targetModule}?archived=${archived}`, document, {
    headers: multiPartHeaders,
  });
  return response;
};


const downloadFile = async (uuid) => {
  const response = await http.get(
    `${apiEndpoint}/public-module/download/${uuid}`,
    { responseType: "arraybuffer" },
  );
  return response;
};


const patchUserGuideArchive = async ({uuid, archive}) => {
  const response = await http.patch(`${apiEndpoint}/${uuid}?archive=${archive}`);
  return response;
};


export default {
  uploadDocument,
  saveDocument,
  getUserGuides,
  downloadFile,
  saveVideoGuide,
  getVideoGuides,
  patchVideoGuideArchive,
  patchUserGuideArchive,
};
